import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ script: 'sub' }, { script: 'super' }],
    [{ color: [] }, { background: [] }],
    ['clean'],
  ],
};

// Available toolbar options:
// ['bold', 'italic', 'underline', 'strike'], // toggled buttons
// ['blockquote', 'code-block'],
// ['link', 'image', 'video', 'formula'],
// [{ header: 1 }, { header: 2 }], // custom button values
// [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
// [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
// [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
// [{ direction: 'rtl' }], // text direction
// [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
// [{ header: [1, 2, 3, 4, 5, 6, false] }],
// [{ color: [] }, { background: [] }], // dropdown with defaults from theme
// [{ font: [] }],
// [{ align: [] }],
// ['clean']; // remove formatting button

const formats = ['bold', 'italic', 'underline', 'strike', 'blockquote', 'script', 'color', 'background'];

interface OnChangeHandler {
  (e: any): void;
}

type Props = {
  value?: string;
  placeholder?: string;
  onChange?: OnChangeHandler;
};

export function TextEditor(props: Props) {
  return (
    <>
      <ReactQuill
        theme="snow"
        value={props.value || ''}
        modules={modules}
        formats={formats}
        onChange={props.onChange}
        placeholder={props.placeholder}
      />
    </>
  );
}
